import styled from '@emotion/styled';
import { Typography } from 'components/Typography';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const Tooltip = styled.div`
  color: ${palette.common.white};
  position: absolute;
  border-radius: ${pxToEm(15)};
  background-color: ${palette.grey[800]};
  font-size: ${pxToEm(12)};
  line-height: ${pxToEm(20)};
  padding: ${pxToEm(7)} ${pxToEm(10)};
  display: none;
  white-space: nowrap;
  top: 100%;
  left: ${pxToEm(78)};
`;

export const Item = styled.div<{ compact?: boolean }>`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: ${({ compact }) => (compact ? pxToEm(250) : pxToEm(167))};
  gap: ${pxToEm(13)};
  position: relative;
  min-height: ${pxToEm(48)};

  &:hover {
    overflow: visible;

    ${Tooltip} {
      display: block;
    }
  }
`;

export const ItemCover = styled.div<{ bg: string }>`
  width: ${pxToEm(48)};
  height: ${pxToEm(48)};
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  border-radius: ${pxToEm(8)};
  flex: none;
`;

export const ItemInfo = styled.div`
  padding: ${pxToEm(6)} 0;
  flex: 1;
  overflow: hidden;
`;

export const ItemCategory = styled(Typography)`
  color: ${palette.grey['A400']};
  font-size: ${pxToEm(10)};
  line-height: 1.6;
  letter-spacing: ${pxToEm(0.2)};
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ItemName = styled(Typography)`
  color: ${palette.grey[800]};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  background-color: transparent;
  padding: 0;
`;
